module.exports = __webpack_public_path__ + "img/remutation_report.e35bd9de.jpg";